<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

#app, .layout-container, body, html {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue